import { MasterDataService } from './../../../services/master-data.service';
import { Component, OnInit } from '@angular/core';
import { IndependenceModel } from 'src/app/analytic-report/declaration.model';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-my-all-client',
  templateUrl: './my-all-client.component.html',
  styleUrls: ['./my-all-client.component.css']
})
export class MyAllClientComponent implements OnInit {
  selectedFinancialYear ;
  financialList;
  reportList ;
  clientIndependence : IndependenceModel;
  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFinancialYear="";
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onViewReport(){
  if(this.selectedFinancialYear== undefined || this.selectedFinancialYear=="" || this.selectedFinancialYear==null){
    this.commonMessageService.swalAlertWithoutIcon('',"Please Select Financial Year.")
    return;
  }
    this.masterDataService.getAllClientIndependence(this.selectedFinancialYear.id,localStorage.getItem('id'),1)
        .subscribe((res) => {
          //this.reportList =res[0].role;
          this.clientIndependence = res;
          console.log("clientIndependence",this.clientIndependence);
          if(this.clientIndependence==null){
            this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
          }
        });

  }

}
